import script from "./WithdrawDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./WithdrawDialog.vue?vue&type=script&lang=ts&setup=true"

import "./WithdrawDialog.vue?vue&type=style&index=0&id=408f4274&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408f4274"]])

export default __exports__